import styled from 'styled-components'
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Box,
  TextField,
} from '@mui/material'

export const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 16px;
    max-width: 400px;
    width: 100%;
    margin: 16px;
    padding: 0;
    position: relative;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  }
  
  .MuiBackdrop-root {
    background-color: rgba(0, 0, 0, 0.5);
  }
`

export const CloseButtonContainer = styled('div')({
  position: 'absolute',
  top: '16px',
  right: '16px',
  zIndex: 1,
})

export const StyledDialogContent = styled(DialogContent)`
  &.MuiDialogContent-root {
    padding: 32px;
    text-align: center;
  }
`

export const HeadingContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  alignItems: 'center',
  textAlign: 'center',
})

export const Title = styled(Typography)`
  && {
    font-weight: bold;
    font-size: 18px;
    color: rgba(0, 0, 0, 0.92);
    letter-spacing: 0em;
    margin-bottom: 8px;
  }
`

export const Subtitle = styled(Typography)`
  && {
    color: rgba(0, 0, 0, 0.68);
    margin-bottom: 32px;
    font-size: 14px;
    letter-spacing: 0em;
    font-weight: 500;
  }
`

export const EmojiContainer = styled(Box)`
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 32px;
`

export const EmojiButton = styled(Box)<{ selected: boolean }>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 8px;
  gap: 5px;
  border-radius: 8px;
  transition: border 0.2s ease-in-out;
  border: 3px solid transparent;
  
  ${({ selected }) => selected && `
    border-color: #20c997;
    & .MuiTypography-root {
      color: #00C99E !important;
    }
  `}

  & * {
    transition: color 0.2s ease-in-out;
  }

  &:hover {
    & .MuiTypography-root {
      color: #00C99E;
    }
  }
`

export const EmojiIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 34px;
  height: 34px;
  width: 34px;
  line-height: 1.15;
`

export const EmojiLabel = styled(Typography)`
  &.MuiTypography-root {
    font-size: 12px;
    color: #000000eb;
    font-weight: 500;
  }
`

export const StyledTextArea = styled(TextField)({
  width: '100%',
  minHeight: '120px',
  '& .MuiOutlinedInput-root': {
    padding: '12px 16px',
    paddingBottom: '32px', // Add space for character counter
  },
  '& fieldset': {
    borderRadius: '8px',
    border: '0.33px solid rgba(0, 0, 0, 0.16)'
  },
  '& .MuiInputBase-input': {
    fontSize: '12px',
    resize: 'none',
    outline: 'none',
    color: '#000000eb'
  },
  '&:focus': {
    boxShadow: '0 0 0 2px rgba(0, 123, 255, 0.1)',
  },
})

export const SubmitButton = styled(Button)`
  & {
    padding: 10px;
    margin-top: 0px;
  }
`

export const TextAreaContainer = styled('div')({
  position: 'relative',
  width: '100%',
  '& .MuiOutlinedInput-root': {
    position: 'relative',
  },
})

export const CharacterCounter = styled('div')({
  position: 'absolute',
  bottom: '8px',
  right: '8px',
  fontSize: '12px',
  color: 'rgba(0, 0, 0, 0.6)',
  pointerEvents: 'none',
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  backdropFilter: 'blur(4px)',
  padding: '2px 6px',
  borderRadius: '4px',
  fontWeight: '500',
  zIndex: 1,
})